import { useState } from "react";

import { faEnvelopeCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { yupResolver } from "@hookform/resolvers/yup";
import Image from "next/image";
import Link from "next/link";
import { Controller, useForm } from "react-hook-form";
import * as yup from "yup";

import styles from "@/assets/styles/pages/rsvp.module.scss";
import { API_ROUTES } from "@/constants";
import { ApiService } from "@/services/ApiService";
import PageSeo from "@/shared/components/PageSeo";

interface IRsvpForm {
    name: string;
    email: string;
    company: string | undefined;
    eventName: string;
    eventDate: string;
    willAttend: NonNullable<boolean | undefined>;
}
const schema = yup
    .object({
        name: yup.string().required("This is a required field."),
        email: yup.string().email().required("This is a required field."),
        company: yup.string().optional(),
        eventName: yup.string().required("This is a required field."),
        eventDate: yup.string().required("This is a required field."),
        willAttend: yup.boolean().required("This is a required field."),
    })
    .required();
export default function Rsvp() {
    const [isLoading, setIsLoading] = useState(false);
    const [isEventSaved, setEventSaved] = useState(false);
    const { control, handleSubmit }
        = useForm({
            mode: "all",
            resolver: yupResolver(schema),
            defaultValues: {
                eventDate: "2025-03-06",
                eventName: "The Gender Index 2025 launch event",
                name: "",
                company: "",
                email: "",
                willAttend: true,
            },
        });
    const onSubmit = async (data: any) => {
        setIsLoading(true);

        const formData: IRsvpForm = {
            ...data,
        };

        await ApiService.post(API_ROUTES.RSVP_EVENT, formData);

        // handleAxiosSuccess(res.data.message, toast);
        setIsLoading(false);
        setEventSaved(true);

        return false;
    };

    return (
        <div className={styles["rsvp"]}>
            <PageSeo title="TGI-Events" />
            <div className="">
                <div className={"grid-wrapper"}>
                    <div className="row no-gutters">
                        <div className={`${styles["rsvp-left"]} col-12 col-lg-7`}></div>
                        <div className={`${styles["rsvp-right"]} col-12 col-lg-5`}>
                            {
                                !isEventSaved
                                    ? <div className="">
                                        <div className={styles["rsvp-right-logo"]}>
                                            <Link href="/">
                                                <Image
                                                    src="/images/TGI-logo-2021.png"
                                                    alt="logo_image"
                                                    width={230}
                                                    height={105}
                                                    loading="lazy"
                                                    quality={1}
                                                />
                                            </Link>
                                        </div>
                                        <div className={styles["rsvp-right-title"]}>
                                            The Gender Index events
                                        </div>

                                        <form onSubmit={handleSubmit(onSubmit)}>
                                            <Controller
                                                name="name"
                                                control={control}
                                                defaultValue=""
                                                render={({ field, fieldState }) => (
                                                    <div className={styles["rsvp-right-textField"]}>
                                                        <input
                                                            placeholder="Name*"
                                                            {...field}
                                                            className={fieldState.error ? "error" : ""}
                                                        />
                                                        <div className={styles["errorMessageContainer"]}>
                                                            {fieldState.error && (
                                                                <span className="errorMessage">
                                                                    {fieldState.error.message}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                                rules={{ required: "This field is required" }}
                                            />
                                            <Controller
                                                name="company"
                                                control={control}
                                                defaultValue=""
                                                render={({ field, fieldState }) => (
                                                    <div className={styles["rsvp-right-textField"]}>
                                                        <input
                                                            placeholder="Company"
                                                            {...field}
                                                            className={fieldState.error ? "error" : ""}
                                                        />
                                                        <div className={styles["errorMessageContainer"]}>
                                                            {fieldState.error && (
                                                                <span className="errorMessage">
                                                                    {fieldState.error.message}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                            />
                                            <Controller
                                                name="email"
                                                control={control}
                                                defaultValue=""
                                                render={({ field, fieldState }) => (
                                                    <div className={styles["rsvp-right-textField"]}>
                                                        <input
                                                            placeholder="Email address*"
                                                            {...field}
                                                            className={fieldState.error ? "error" : ""}
                                                        />
                                                        <div className={styles["errorMessageContainer"]}>
                                                            {fieldState.error && (
                                                                <span className="errorMessage">
                                                                    {fieldState.error.message}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                                rules={{ required: "This field is required" }}
                                            />
                                            <div className={styles["rsvp-right-alertText"]}>
                                                {/* Are you able to attend The Gender Index Bristol Roadshow on Thursday the 21st November 2024? */}
                                                Are you able to attend The Gender Index 2025 launch event on Wednesday 6th March? (11.30AM - 2.30PM)
                                            </div>
                                            <div className={styles["rsvp-right-radioGroup"]}>
                                                <Controller
                                                    name="willAttend"
                                                    control={control}
                                                    defaultValue={true}
                                                    rules={{ required: "This field is required" }}
                                                    render={({ field }) => (
                                                        <>
                                                            <label>
                                                                <input
                                                                    type="radio"
                                                                    value={1}
                                                                    checked={field.value === true}
                                                                    onChange={() => field.onChange(true)}
                                                                />
                                                                Yes, I can make it
                                                            </label>
                                                            <label>
                                                                <input
                                                                    type="radio"
                                                                    value={0}
                                                                    checked={field.value === false}
                                                                    onChange={() => field.onChange(false)}
                                                                />
                                                                No, sorry I can&apos;t make it
                                                            </label>
                                                        </>
                                                    )}
                                                />
                                            </div>
                                            <button className={`${styles["rsvp-right-button"]} btn-pink btn-small`} type="submit" disabled={isLoading}>Submit</button>
                                        </form>
                                    </div>
                                    : <div className={styles["rsvp-right-eventSaved"]}>
                                        <div className={styles["rsvp-right-eventSaved-logo"]}>
                                            <Link href="/">
                                                <Image
                                                    src="/images/TGI-logo-2021.png"
                                                    alt="logo_image"
                                                    width={230}
                                                    height={105}
                                                    loading="lazy"
                                                />
                                            </Link>
                                        </div>
                                        <div className={styles["rsvp-right-eventSaved-text"]}>
                                            Message received, thank you!
                                        </div>
                                        <div className={styles["rsvp-right-eventSaved-icon"]}>
                                            <FontAwesomeIcon icon={faEnvelopeCircleCheck} color="#00A7B7" />
                                        </div>
                                    </div>
                            }
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}

